import { Expose } from 'class-transformer';
import { IAttachment } from '../interfaces';
import { BaseModel } from './base.model';

export class AttachmentModel extends BaseModel implements IAttachment {
  @Expose()
  id!: number;

  @Expose()
  name!: string;

  @Expose()
  contentType!: string;

  @Expose()
  keyPath!: string;

  @Expose()
  attrs!: {
    key: string;
    section?: string;
  };
}

export class BlobAttachmentModel extends AttachmentModel {
  @Expose()
  type = 'blob';

  @Expose()
  loader!: any;
}
